export default Object.freeze({
  // ---------------------------- Backend IP ----------------------------
  REQUEST_IP_ADDRESS: `${window.location.origin}/scope-dp-5-canais/api/`,

  // ---------------------------- Language ----------------------------
  LOCAL_STORAGE_KEY: "dp-language",
  ES_LANG_KEY: "es",
  EN_LANG_KEY: "en",
  PT_LANG_KEY: "pt",
  DE_LANG_KEY: "de",
  //  ---------------------------- Device Status Analyzer -------------------
  GOOD: "ok",
  ATTENTION: "attention",
  BAD: "bad",

  // ---------------------------- Page Scaling Modifiers ----------------------------
  SCALING_FACTOR_LIVE_TOPOLOGY: 0.60,
  SCALING_FACTOR_LOG: 0.54,

  // ---------------------------- Oscilloscope ----------------------------
  OSCILLOSCOPE_CHART_ID: "osc-page-chart-id",
  OSCILLOSCOPE_CHART_ID_AB: "osc-page-chart-id-ab",
  BA_CHECKBOX_VAL: "ba-check",
  AB_CHECKBOX_VAL: "ab-check",
  PLAY_REFRESH_INTERVAL_MS: 200,
  AUTO_VISUALIZATION_REFRESH_MS: 1500,
  AUTOMATIC_CHECKBOX_VAL: "auto-check",
  MANUAL_CHECKBOX_VAL: "manual-check",

  LOADING_IMG: "loading-img",
  // ---------------------------- Bar Graph ----------------------------
  BAR_GRAPH_CHART_ID: "bar-gr-chart-id",

  AMPLITUDE_ID: "amp-id",
  MIN_AMPLITUDE_ID: "min-amp-id",

  CHECKBOX_ADDR_VAL: "check-addr",
  CHECKBOX_ASC_VAL: "check-asc",
  CHECKBOX_DESC_VAL: "check-desc",

  MAX_DEV_PER_PAGE: 15,

  // ------------------- Hexadecimal value of Colors -------------------
  RED_HEX: "#f44336",
  YELLOW_HEX: "#fdd835",
  GREEN_HEX: "#00c853",
  PURPLE_HEX: "#ab47bc",
  TEAL_HEX: "#38C7BD",

  FADED_GREEN_HEX: "rgba(0, 200, 83, 0.5)",
  FADED_YELLOW_HEX: "rgba(253, 216, 53, 0.5)",
  FADED_RED_HEX: "rgba(244, 67, 54, 0.5)",

  // ---------------------------- Report ----------------------------
  CONFORM: "C",
  CONFORM_W_RESTRICTION: "CWR",
  NON_CONFORM: "NC",
  LABELS_FONT_SIZE: "14px",
  LIVE_LIST_ELEMENTS_PER_PAGE: 25,
  RANDOMIZER_CONSTANT: 234567,
  MAX_NUM_OF_LOG_EVENTS: 200,

  // ---------------------------- Configuration ----------------------------
  MAX_NOTE_LENGTH: 280,

  // ------------------------------- AUTH STR ----------------------------
  AUTH_STR: "f4610aa514477222afac2b77f971d069780ca2846f375849f3dfa3c0047ebbd1",

  FILE_UPDATE_TYPE: "file-update",
  NTP_UPDATE_TYPE: "turnNtpOn",

  NOT_UPDATING: "notUpdating",
  UPDATE_FILES_FOUND: "updateFilesFound",
  FINISHED_UPDATING: "finishedUpdating",
  RESTARTING_MONITOR: "restartingMonitor",

  UPDATE_VERIFY_MASTER: "updatingVerifyMaster",
  UPDATE_DEVICES_CHANNEL: "updatingDevicesPerChannel",
  UPDATE_MANUAL_CHANNELS: "updatingManualChannels",

  // ------------------------------- NTP UPDATE STATUS ----------------------------
  NTP_UPDATE_NOT_STARTED: "notUpdating",
  NTP_UPDATE_START: "start",
  NTP_UPDATE_SUCCESS: "sucess",
  NTP_UPDATE_FAIL: "fail",

  // ------------------------------- TS EXPERT ----------------------------
  TERMINATION_OFF_PROBLEM_TYPE: "terminationOFF",
  NO_POWER_SUPPLY_PROBLEM_TYPE: "noPowerSupplyTermination",
  HIGH_RESISTANCE_PROBLEM_TYPE: "highResistance",
  A_NOT_OK_PROBLEM_TYPE: "aNotOk",
  B_NOT_OK_PROBLEM_TYPE: "bNotOk",
  LONG_CABLE_PROBLEM_TYPE: "longCable",
  NOISE_PROBLEM_TYPE: "noise",
  REFLECTION_PROBLEM_TYPE: "reflection",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE: "fiberLowerLimitMaintenanceRequired",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE: "fiberLowerLimitUrgentMaintenance",
  FIBER_SIGNAL_LOSS_PROBLEM_TYPE: "fiberSignalLost",

  // ---------------------------- WLAN Config ----------------------------
  CONNECTED_STATUS: "connected",
  DISCONNECTED_STATUS: "disconnected",

  DHCP_MODE: "dhcp",
  FIXED_IP_MODE: "fixedIp",

  // ---------------------------- Segment Devices ----------------------------
  IN_SEGMENT: "inSegment",
  POSSIBLY_IN_SEGMENT: "possiblyInSegment",
  NOT_IN_SEGMENT: "notInSegment",

  IN_SEGMENT_LIST: "inSegmentDevices",
  OTHER_LIST: "otherDevices",

  // ---------------------------- Channels Time ----------------------------
  MIN_INTERVAL: 1,    // 1 minuto
  MAX_INTERVAL: 60,   // 60 minutos (1 hora)

  // ---------------------------- Devices Channels ----------------------------
  MANUAL_CHANNEL: "MANUAL_CHANNEL",
  VERIFY_MASTER: "VERIFY_MASTER",
  DEV_CHANNELS: "DEVICE_CHANNELS",
});
